export default {"src":"/_next/static/media/footer-mobile-white-bg.5dcb8baa.svg","height":406,"width":375,"blurWidth":0,"blurHeight":0};